import { Button } from '@mui/material';
import React, { useCallback, useState } from 'react';
import RequestSamplesDialog from './RequestSamplesDialog';


function RequestBiosamplesButton() {
    const [openDialog, setOpenDialog] = useState(false);
    const handleToggle = useCallback(() => {
        setOpenDialog(!openDialog);
    }, [openDialog, setOpenDialog]);
    return (
        <>
            <Button color="primary" variant="contained" onClick={handleToggle}>Request access to biosamples</Button>
            {!!openDialog && <RequestSamplesDialog onClose={handleToggle} />}
        </>
    );
}


export default RequestBiosamplesButton;
